import React from "react";
import LogsTable from "./components/LogsTable";
import Filters from "./components/Filters";
import "./DashboardLogger.scss";

const Index = () => {
  const [tableParams,setTableParams] = React.useState({ current: 1, pageSize: 10 });
  return (
    <div className="dashboard-logger-container">
      <div className="dashboard-logger-title">Dashboard Activity Logs</div>
      <div className="dashboard-logger-filters">
        <Filters tableParams={tableParams} setTableParams={setTableParams} />
      </div>
      <div className="dashboard-logger-table">
        <LogsTable tableParams={tableParams} setTableParams={setTableParams} />
      </div>
    </div>
  );
};

export default Index;
